import React from 'react';
import { Row } from './row';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';

export const TotalPaidRow = ({ providers, totalPaid }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn fontSize={16} isBold={true}>
      Total Paid
    </DescriptionColumn>
    <ProviderColumn colSpan={providers.length} isBold={true}>
      {totalPaid}
    </ProviderColumn>
  </Row>
);
